export type SliderDataItem = {
  url: string;
  alt: string;
  caption: string;
  subCaption: string;
};

export const SliderData: SliderDataItem[] = [
  {
    url: 'assets/images/slide-2.png',
    alt: 'Slide 2',
    caption: 'Effortless Inventory Control',
    subCaption:
      'Streamline operations, track stock in real time, and ensure every product is in the right place at the right time.',
  },
  {
    url: 'assets/images/slide-1.png',
    alt: 'Slide 1',
    caption: 'Precision at Every Count',
    subCaption:
      'Stay organized, minimize errors, and maximize efficiency with a system built to support your business at every step.',
  },
  {
    url: 'assets/images/slide-3.png',
    alt: 'Slide 3',
    caption: 'Optimize Every Movement',
    subCaption:
      'Enhance productivity, reduce delays, and achieve seamless workflows with a system designed for precision and speed.',
  },
];
